module.exports = __webpack_public_path__ + "static/beach-splash.1342d5ff.jpg";